module.exports = __webpack_public_path__ + "assets/img/subtitle-back.ac64e4da.png";